<template>
    <v-dialog
        :value="isOpen"
        max-width="450px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Palety
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="currentPalletsList"
                    :mobile-breakpoint="0"
                    hide-default-footer
                >
                    <template #item.parameter="{item}">
                        {{ item.parameter }}
                    </template>
                    <template slot="no-results">
                        <p class="text-center">
                            Brak danych
                        </p>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>

                <v-spacer />

                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zamknij"
                    @click="onRefresh"
                >
                    Odśwież
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import pagination from '@/mixins/dataTablePagination'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'PalletsDialogOffsetReporting',
    mixins: [
        pagination,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        palletsList: {
            type: Array,
            default: () => []
        },
        reportId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            updatedPalletsList: null,
            palletsRefreshed: false,
            headers: [
                {
                    text: 'Numer palety',
                    value: 'parameter',
                    sortable: false,
                    width: 400,
                    align: 'center'
                },
            ],
        }
    },
    computed: {
        currentPalletsList() {
            if (this.palletsRefreshed) return this.updatedPalletsList 

            return this.palletsList
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close', this.currentPalletsList)
        },
        onRefresh() {
            this.$store.dispatch('toggleCircularLoader', true)
            this.$store.dispatch('reports/getReport', this.reportId)
                .then(response => {
                    this.palletsRefreshed = true
                    this.updatedPalletsList = response.reportPallets
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$store.dispatch('toggleCircularLoader', false)
                })
        }
    }
}
</script>